import utils from '../utils'
import api from '../apis'
export default {
    state: {
        conferService: {},
    },
    getters: {
        conferService(state) {
            return state.conferService;
        }
    },
    mutations: {
        setconferService(state, conferService) {
            state.conferService = conferService;
        },
        removeconferService(state) {
            state.conferService = {};
        }
    },
    actions: {
        removeconferService({
            commit
        }) {
            commit('removeconferService')
        },
        loadconferService({
            commit
        }, UserID, CompanyID) {
            return api.system.getConferService({
                failTips: false
            }).then(function (json) {
                if (!json.data.isSucc) {
                    return json;
                }
                commit('setconferService', json.data.result);
                return json;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/conferService.js